<template>
  <router-link
    v-slot="{ href, route, navigate, isActive, isExactActive }"
    :to="{ name: 'SettingCanvas', params: { uuid: id } }"
  >
    <div class="settings-btn" @click="navigate">
      <strong>{{ 'All Settings' | trans }}</strong><i class="fa lh-inherit fa-chevron-right"></i>
    </div>
  </router-link>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'

export default {
  name: "AdvancedSettingsBtn",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
.settings-btn {
  display: flex;
  height: 38px;
  padding: 7px 20px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid #1266F1;
  background: #1266F1;
  cursor: pointer;
}
</style>
